'use client';

import { c as _c } from "react/compiler-runtime";
import { supporterDetailsQuery } from '../queries.ts';
import { getSupporterEmail, getSupporterFullName, getSupporterInitials, getSupporterPreferredName } from '../utils/name-format.ts';
import { useSupporterQuery } from './base.ts';
export enum NameFormats {
  preferred = 'preferred',
  full = 'full',
  initials = 'initials',
  email = 'email',
}
export const useSupporterDetails = () => {
  return useSupporterQuery(supporterDetailsQuery);
};
export const useSupporterName = format => {
  const $ = _c(13);
  const query = useSupporterDetails();
  const {
    data: details
  } = query;
  if (!details) {
    let t0;
    if ($[0] !== query) {
      t0 = {
        ...query,
        name: undefined
      };
      $[0] = query;
      $[1] = t0;
    } else {
      t0 = $[1];
    }
    return t0;
  }
  let name;
  bb0: switch (format) {
    case NameFormats.full:
      {
        let t0;
        if ($[2] !== details) {
          t0 = getSupporterFullName(details);
          $[2] = details;
          $[3] = t0;
        } else {
          t0 = $[3];
        }
        name = t0;
        break bb0;
      }
    case NameFormats.initials:
      {
        let t0;
        if ($[4] !== details) {
          t0 = getSupporterInitials(details);
          $[4] = details;
          $[5] = t0;
        } else {
          t0 = $[5];
        }
        name = t0;
        break bb0;
      }
    case NameFormats.email:
      {
        let t0;
        if ($[6] !== details) {
          t0 = getSupporterEmail(details);
          $[6] = details;
          $[7] = t0;
        } else {
          t0 = $[7];
        }
        name = t0;
        break bb0;
      }
    default:
      {
        let t0;
        if ($[8] !== details) {
          t0 = getSupporterPreferredName(details);
          $[8] = details;
          $[9] = t0;
        } else {
          t0 = $[9];
        }
        name = t0;
      }
  }
  let t0;
  if ($[10] !== name || $[11] !== query) {
    t0 = {
      ...query,
      name
    };
    $[10] = name;
    $[11] = query;
    $[12] = t0;
  } else {
    t0 = $[12];
  }
  return t0;
};